import BaseClient from '@/app/model/api/response/baseApiClient'

class PasswordResettingApi extends BaseClient {
  public doPasswordResetting (token: string, bodyData: {[key: string]: any|string}) {
    const path = '/v1/setting/user/password'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ token: decodeURIComponent(token) })
    url.search = params.toString()

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(decodeURI(url.href), 'PUT')
  }
}

export default new PasswordResettingApi()
